import * as Yup from "yup";
import { isAfter, isValid } from "date-fns";

const schema = Yup.object().shape({
  empresa_id: Yup.string()
    .typeError("Selecione uma empresaa")
    .required("Selecione uma empresa"),
  data_vencimento: Yup.date()
    .typeError("Data inválida")
    .test("data-futura", "Data inválida", function (value) {
      if (!value) return false;
      const today = new Date();
      today.setHours(0, 0, 0, 0); // Remove a hora para comparar apenas a data
      return isValid(value) && isAfter(value, today);
    })
    .required("Informe a data de vencimento"),
  amount: Yup.number()
    .typeError("Informe um valor válido")
    .positive("O valor deve ser maior que zero")
    .required("Informe o valor"),
});

export { schema };
